import React from "react";
import { Star, CheckCircle2 } from "lucide-react";
import MatrixRain from "../components/MatrixRain";
import ApplicationForm from "../components/ApplicationFormSlides";
import {
  FoundersSection,
  Testimonials,
  CTASection,
  ResultsWall,
  ReviewsSection,
  LiveReviewsStrip,
  BottomCTA,
  Footer,
} from "../components/Sections";
import { ASSETS } from "../mock";
import { usePageTracking } from "../analytics";

const HeroContent = () => (
  <div className="mx-auto w-full max-w-xl lg:mx-0">
    <span className="open-badge">
      <span className="open-dot" />
      APPLICATION NOW OPEN
    </span>
    <h2 className="mt-6 text-4xl font-bold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-[54px]">
      The Market Isn&rsquo;t Random. It&rsquo;s{" "}
      <span className="text-[#16E36F]">Programmed</span>.
    </h2>
    <p className="mt-5 text-lg leading-relaxed text-neutral-400">
      Study how <span className="font-bold text-[#16E36F]">Time and Price</span>{" "}
      work together. Build an objective trading process through structured
      lessons and personal coaching.
    </p>
    <div className="mt-5 flex items-center gap-2.5">
      <span className="flex items-center gap-1">
        {[...Array(5)].map((_, i) => (
          <Star key={i} size={16} className="text-[#16E36F]" fill="#16E36F" />
        ))}
      </span>
      <span className="text-sm font-semibold text-white">
        Trusted by 400+ students
      </span>
    </div>
    <p className="mt-5 text-sm text-neutral-500">
      Let&rsquo;s see if The Matrix Unlocked is a fit for you.
    </p>
    <div className="mt-6">
      <h3 className="text-sm font-bold uppercase tracking-wide text-white">
        Inside The Matrix Unlocked
      </h3>
      <ul className="mt-4 space-y-2.5" data-testid="inside-tmu-checklist">
        {[
          "12-Week Structured Program",
          "Personal Coaching & Accountability",
          "Exclusive Algorithmic Software",
          "Trading Journal & Progress Tracking",
          "Lifetime Community & Educational Library Access",
          "Private In-Person Events",
        ].map((item) => (
          <li
            key={item}
            className="flex items-center gap-2.5 text-[15px] text-neutral-300"
          >
            <CheckCircle2
              size={18}
              className="shrink-0 text-[#16E36F]"
            />
            {item}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

const ApplicationPage = () => {
  usePageTracking("application");

  return (
    <div className="min-h-screen bg-black">
      {/* Hero + form */}
      <header className="relative overflow-hidden">
        <div className="absolute inset-x-0 top-0 h-[420px]">
          <MatrixRain />
          <div className="matrix-fade" />
        </div>

        <div className="relative z-10 mx-auto flex max-w-6xl flex-col items-center px-5 pt-10">
          <img
            src={ASSETS.logoEmblem}
            alt="The Matrix Unlocked"
            className="h-16 w-auto sm:h-20"
          />
          <h1 className="mt-4 text-center text-3xl font-semibold tracking-tight text-white sm:text-4xl md:text-[44px]">
            <span className="text-[#16E36F]">Apply</span> For The Matrix
            Unlocked Below
          </h1>
        </div>

        <div className="relative z-10 mx-auto mt-10 grid w-full max-w-6xl grid-cols-1 items-center gap-10 px-5 pb-6 lg:grid-cols-[0.82fr_1.18fr] lg:gap-12">
          <HeroContent />
          <ApplicationForm />
        </div>
      </header>

      <LiveReviewsStrip />
      <FoundersSection />
      <Testimonials />
      <CTASection />
      <ResultsWall />
      <ReviewsSection />
      <BottomCTA />
      <Footer />
    </div>
  );
};

export default ApplicationPage;
